/**
 * THIS FILE IS AUTO-GENERATED
 * DON'T MAKE CHANGES HERE
 */
import { typedDependencies } from './dependenciesTyped.generated.js';
import { createEqualScalar } from '../../factoriesAny.js';
export var equalScalarDependencies = {
  typedDependencies,
  createEqualScalar
};


//////////////////
// WEBPACK FOOTER
// ./~/mathjs/lib/esm/entry/dependenciesAny/dependenciesEqualScalar.generated.js
// module id = STL4
// module chunks = 3